export const dashboard = {
  all: "Dashboard",
};

// Coin -------------------------------------------------
export const coin = {
  all: "Audit/All/Coin",
  delete: "Audit/Delete/Coin/",
  new: "Audit/New/Coin",
  edit: "Audit/Edit/Coin/",
};
// Audits -------------------------------------------------
export const audit = {
  all: "Audit",
  filter: "Audit/Filter/",
  filterStatus: "Audit/FilterStatus/",
  delete: "Audit/Delete/",
  new: "Audit/New",
  edit: "Audit/Edit/",
  rating: "Audit/Edit/Rate/",
  status: "Audit/Edit/ChangeStatus/",
  publish: "Audit/Edit/ChangePublish/",
  slug: "Audit/Edit/Slug/",
  network: "Audit/Rpcs",
  currency: "Audit/Currency",
  getDataForBtns: "Audit/CrawlerData/",
  resetValidation: "Audit/Edit/ChangeIsValid/",
  deleteTransaction: "Audit/Edit/DeleteIsValid/",
  deleteUser: "Audit/Edit/DeleteUser/",
  deleteBalance: "Audit/Edit/DeleteBalance/",
};

export const auditCategory = {
  cat: "AuditCategory/All",
  all: "AuditCategory",
  filter: "AuditCategory/Filter/",
  delete: "AuditCategory/Delete/",
  new: "AuditCategory/New",
  edit: "AuditCategory/Edit/",
};

// Posts -------------------------------------------------
export const post = {
  all: "Post",
  filter: "Post/Filter/",
  delete: "Post/Delete/",
  new: "Post/New",
  edit: "Post/Edit/",
  publish: "Post/Edit/changePublish/",
  slug: "Post/Edit/Slug/",
};

export const postCategory = {
  cat: "PostCategory/All",
  all: "PostCategory",
  filter: "PostCategory/Filter/",
  delete: "PostCategory/Delete/",
  new: "PostCategory/New",
  edit: "PostCategory/Edit/",
};

// Contacts -------------------------------------------------

export const contacts = {
  all: "Contact",
  filter: "Contact/Filter/",
  delete: "Contact/Delete/",
  new: "Contact/New/",
  edit: "Contact/Edit/",
  status: "Contact/Edit/ChangeUnread/",
};

// Roles -------------------------------------------------

export const role = {
  all: "Role",
  delete: "Role/Delete/",
  new: "Role/New",
  check: "Role/UserPermissions/",
  edit: "Role/Edit/",
  cat: "Role/All",
};

// Users -------------------------------------------------

export const auth = {
  all: "Auth",
  login: "Auth/Login/",
  delete: "Auth/Delete/",
  new: "Auth/Register",
  edit: "Auth/Edit/",
};

// Settings -------------------------------------------------

export const settings = {
  all: "Setting/Descriptions",
  edit: "Setting/Descriptions/Edit/",
  password: "Setting/ChangePassword/",
};

export const team = {
  all: "Team",
  filter: "Team/Filter/",
  delete: "Team/Delete/",
  new: "Team/New/",
  edit: "Team/Edit/",
};
export const faq = {
  all: "Faq",
  filter: "Faq/Filter/",
  delete: "Faq/Delete/",
  new: "Faq/New/",
  edit: "Faq/Edit/",
};
export const service = {
  all: "Service",
  filter: "Service/Filter/",
  delete: "Service/Delete/",
  new: "Service/New/",
  edit: "Service/Edit/",
};
export const logs = {
  all: "Setting/Logs",
};



// WEBPACK FOOTER //
// ./src/axious.js